import { useEffect } from 'react';
import VehiclesDataTable from './VehiclesDataTable/VehiclesDataTable';

function Vehicles() {

  // #region templates

  const viewTemplate = (
    <>
      <article>
        <section>
          <h1>
            Vehículos
          </h1>
        </section>
        <section>
          <VehiclesDataTable />
        </section>
      </article>
    </>
  );

  // #endregion

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
  }, []);

  return (
    <>
      {viewTemplate}
    </>
  );
}

export default Vehicles;